"use strict";
const Ajv = require("ajv");
function createAjvWithCustomFormats(obj) {
    const ajv = new Ajv(obj);
    // Add custom "password" format
    ajv.addFormat("password", /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()\-+=_{}[\]:;"'<>,.?/|\\]).{8,64}$/);
    return ajv;
}
module.exports = createAjvWithCustomFormats;
